import styled from '@emotion/styled';
import { useTranslation } from 'src/hooks';
import { Chip } from 'src/components/atoms';

const StyledChip = styled(Chip)(
  ({ theme }) => `
  grid-area: visibility;
  height: 1.5rem;
  width: 4rem;
  background-color: transparent;
  border: 1px solid ${theme.palette.common.white};
  margin-left: auto;

  span {
    color: ${theme.palette.common.white};
    padding: 0 0.5rem;
    font-size: 12px;
  }
`
);

export const HiddenChip = () => {
  const { t } = useTranslation();

  return <StyledChip color='primary' label={t('pages.feed.myme.hidden')} />;
};
